module.exports = __webpack_public_path__ + "img/Wp_2088.a0b693ac.png";